<template>
  <!-- 发起审批，审批流展示 -->
  <div class="workflow" style="padding-top: 20px;">
    <template v-if="isShowrokFlow">
      <div class="clearfix" v-for="(item,index) in barData" :key="index">
        <!-- 审批 -->
        <div class="botLine" v-if="item.ApprovalMemberList.length>0">
          <div class="leftLine fl">
            <div class="dot"></div>
            <div class="line" v-if="data[index+1]"></div>
          </div>
          <div class="leftMsg fl">
            <div class="type">{{item.ApprovalMemberList.length>0?item.ApprovalMemberList[0].DisplayName:'审批人'}}</div>
            <div
              class="typeMsg"
              v-if="item.ApprovalMemberType === 0 && item.ApprovalMemberList.length > 0"
            >{{item.ApprovalMemberList.length}}人审批</div>
            <div
              class="typeMsg"
              v-if="item.ApprovalMemberType !== 0 && item.ApprovalMemberList.length > 0"
            >请选择审批人</div>
            <div class="typeMsg" v-if="item.ApprovalMemberList.length === 0">暂无审批人</div>
          </div>
          <div class="content fr" v-if="item.ApprovalMemberList.length===0">
            <!-- 无审批人 -->
          </div>
          <!-- 指定成员审批且大于5人 -->
          <!-- <div class="content fr" v-if="item.ApprovalMemberType===0 && item.ApprovalMemberList.length>5">
            <div class="fr">
              <div class="more" @click="showmoreshenpi(index)"></div>
              <p>更多</p>
            </div>
            <div class="fr" v-for="user in item.ApprovalMemberList.slice(0,4)" :key="user.UserID">
              <div class="msg">{{showName(user.FullName)}}</div>
              <p>{{user.FullName}}</p>
            </div>
          </div> -->
          <!-- 指定成员审批且小于5人或等于5人 -->
          <div
            class="content fr"
            v-if="item.ApprovalMemberType===0"
          >
            <div class="fr" v-for="user in item.ApprovalMemberList" :key="user.UserID">
              <div class="msg">{{showName(user.FullName)}}</div>
              <p>{{user.FullName}}</p>
            </div>
          </div>
          <!-- 非指定成员审批时自选1人 -->
          <div class="content fr" v-if="item.ApprovalMemberType!==0 &&item.ApprovalMemberList.length>0">
            <div class="fr" v-if="item.ApprovalMemberType!==0 &&item.ApprovalMemberList.length>1">
              <div class="chose" @click="chosemoreshenpi(index)"></div>
              <p>选择</p>
            </div>
            <div class="fr" v-for="user in item.sureData" :key="user.UserID">
              <div class="msg">{{showName(user.FullName)}}</div>
              <p>{{user.FullName}}</p>
            </div>
          </div>
        </div>
        <!-- 抄送 -->
        <div class="botLine" v-if="item.CcMemberList.length>0&&item.NodeType===1">
          <div class="leftLine fl">
            <div class="dot"></div>
            <div class="line" v-if="data[index+1]"></div>
          </div>
          <div class="leftMsg fl">
            <div class="type">{{item.CcMemberList[0].DisplayName?item.CcMemberList[0].DisplayName:''}}</div>
            <div class="typeMsg">抄送{{item.CcMemberList.length}}人</div>
          </div>
          <!-- 抄送人大于5人或是5人 -->
          <div class="content fr" v-if="item.CcMemberList.length>5|| item.CcMemberList.length===5">
            <div class="fr" @click="addCoper(index)">
              <div class="add"></div>
              <p>添加</p>
            </div>
            <div class="fr">
              <div class="more" @click="showMoreCc(index)"></div>
              <p>更多</p>
            </div>
            <div class="fr pr" v-for="(user,index) in item.CcMemberList.slice(0,3)" :key="user.UserID">
              <!-- <div class="dot"></div> -->
              <div class="msg">{{showName(user.FullName)}}</div>
              <p>{{user.FullName}}</p>
              <van-icon v-if="user.isDel!==undefined&&user.isDel" name="clear" class="del-ccPep" @click="delPeps(index,item.CcMemberList)" />
            </div>
          </div>
          <!-- 少送人少于5人 -->
          <div class="content fr" v-if="item.CcMemberList.length<5 ">
            <div class="fr" @click="addCoper(index)">
              <div class="add"></div>
              <p>添加</p>
            </div>
            <div class="fr pr" v-for="(user,index) in item.CcMemberList.slice(0,4)" :key="user.UserID">
              <!-- <div class="dot"></div> -->
              <div class="msg">{{showName(user.FullName)}}</div>
              <p>{{user.FullName}}</p>
              <van-icon v-if="user.isDel!==undefined&&user.isDel" name="clear" class="del-ccPep" @click="delPeps(index,item.CcMemberList)" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-if="!isShowrokFlow" class="no-workflow">审批人未设置审批权限，请联系管理员</div>
    <!-- 非指定成员时选择1个审批人 -->
    <van-popup v-model="choseshenpi" position="bottom" :style="{ width:'100%',height: '100%' }">
      <span @click="close" style="position: fixed;right: 4%;line-height: 55px;font-size: 14px;">取消</span>
      <div class="pupCon">
        <h3 class="title">选择审批人员</h3>
        <p class="msg">{{shenpiArr.length}}人审批</p>
        <div>
          <van-radio-group style="width:100%;margin-top:25px;margin-bottom: 60px;" v-model="radio" @change="choseId">
            <van-cell-group v-for="item in shenpiArr" :key="item.UserID">
              <van-cell :title="item.FullName" clickable>
                <van-radio slot="right-icon" :name="item.UserID" />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
      <van-button type="info" @click="choseshenpi=false" style="height: 40px; line-height: 40px;position:fixed;bottom:15px;width:95%;margin-left:2.5%;" round size="large">确定</van-button>
    </van-popup>
    <!-- 查看更多审批人 -->
    <van-popup closeable v-model="shenpi" position="bottom" :style="{ height: '100%' }">
      <div class="pupCon">
        <h3 class="title">查看更多</h3>
        <p class="msg">{{shenpiArr.length}}人审批</p>
        <div class="leaveType">
          <div v-for="item in shenpiArr" :key="item.UserID">
            <h1>{{showName(item.FullName)}}</h1>
            <p>{{item.FullName}}</p>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- 展示更多抄送人 -->
    <van-popup closeable v-model="chaosong" position="bottom" :style="{ height: '100%',backgroundColor:'#F5F5F5' }">
      <div class="pupCon">
        <h3 class="title">查看更多</h3>
        <p class="msg">抄送{{chaosongArr.length}}人</p>
        <div class="leaveType">
          <div v-for="(item,index) in chaosongArr" :key="item.UserID" class="pr">
            <h1>{{showName(item.FullName)}}</h1>
            <p>{{item.FullName}}</p>
            <van-icon v-if="item.isDel!==undefined&&item.isDel" name="clear" class="del-ccPep" @click="delPep(index)" />
          </div>
          <!-- <div>
            <h1 class="add" @click="addCoper(curInx)"></h1>
            <p></p>
          </div> -->
        </div>
      </div>
    </van-popup>
    <AddPep :isShowPep="isShowPep" :titles="titles" :addPepList="addPepList" @listenToChildClose="closeAddPep" @listenToChildChoice="getPepList"/>
  </div>
</template>
<script>
import AddPep from '@/components/workFlow/AddPep'
export default {
  name: "CreatFlow",
  components:{
    AddPep
  },
  props: {
    commit: {
      //保存 函数
      type: Function
    },
    data: {
      type: Array
    }
  },
  data() {
    return {
      titles:'添加抄送人',
      addPepList:[],
      isShowPep:false,
      shenpi: false,
      shenpiArr: [],
      choseshenpi: false,
      chaosong: false,
      chaosongArr: [],
      radio: "",
      showShenpiArr: [],
      moreCoper: false,
      //barData: [],
      curInx: "",
      apIndex:'',
      isShowrokFlow:true
    };
  },
  created() {
    // console.log(this.data);
    // this.barData = this.data;
  },
  computed: {
    barData() {
      return this.data;
    }
  },
  watch:{
    barData:{
      handler(vals){
        // 选择好申批人切换周期性时间或者连续性时间，没选中问题
        if(typeof this.apIndex === 'number'){
          this.data[this.apIndex]['sureData'] === undefined?this.radio = '' :'';
        }
        this.isShowrokFlow=true
        vals.map(item=>{
          if(item.NodeType===2&&item.ApprovalMemberList.length===0){
            this.isShowrokFlow=false
          }
          if(item.NodeType===2&&item.ApprovalMemberList.length===1){
            this.$set(item,'sureData',item.ApprovalMemberList)
          }
        })
      },
      immediate:true
    }
  },
  methods: {
    showName(name) {
      // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
      if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
        return name.length > 3 || name.length === 3 ? name.slice(-2) : name;
      } else if (/^[A-Za-z]+$/g.test(name)) {
        // 纯英文名只展示两个字母
        return name.slice(0, 2);
      } else {
        // 其他
        return name.slice(0, 2);
      }
    },
    // 展示更多抄送人
    showMoreCc(i) {
      this.curInx = i;
      this.chaosong = true;
      this.chaosongArr = this.data[i].CcMemberList;
    },
    // 展示更多审批人
    showmoreshenpi(i) {
      this.shenpi = true;
      this.shenpiArr = this.data[i].ApprovalMemberList;
    },
    // 展示可选审批人
    chosemoreshenpi(i) {
      // this.radio =''
      this.apIndex = i
      this.choseshenpi = true;
      this.shenpiArr = this.data[i].ApprovalMemberList;
    },
    close() {
      this.radio = ''
      this.choseshenpi = false
      this.barData[this.apIndex].sureData = [];
    },
    // 选择一个审批人
    choseId(data) {
      let show = this.shenpiArr.filter(item => {
        if (item.UserID === data) {
          return item;
        }
      });
      this.showShenpiArr = show;
      this.barData[this.apIndex].sureData = this.showShenpiArr;
      // console.log(this.barData[this.],")
    },
    // 添加抄送人
    addCoper(i) {
      this.barData[i].CcMemberList.map(item=>{
        if(item.isDel===undefined){
          this.$set(item,'isDel',false)
        }
      })
      this.addPepList=this.barData[i].CcMemberList
      this.isShowPep=true
      this.$store.commit('attendance/setAddCCIndex', i)
      // this.$store.commit('attendance/setBarData', this.barData)
      // this.$router.push({path: "/home/TeacherLeave/coper"});
    },
    closeAddPep(val){
      this.isShowPep=val
    },
    getPepList(list){
      this.isShowPep=false
      list.map(item => {
        if(item.isDel===undefined){
          this.$set(item,'isDel',true)
        }
      })
      this.barData[this.$store.state.attendance.addCCIndex].CcMemberList=list
    },
    delPep(i){
      this.barData[this.$store.state.attendance.addCCIndex].CcMemberList.splice(i,1)
    },
    delPeps(i,val){
      val.splice(i,1)
    }
  }
};
</script>

<style lang="less" scoped>
.no-workflow{
  padding:30px;
  color:red;
}
.del-ccPep{
  position: absolute;
  top: -10px;
  right:-10px;
  font-size: 32px;
  color:#F87C7C;
}
.workflow {
  width: 100%;
  height: auto;
  margin-bottom: 130px;
}
.workflow .tit {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  line-height: 55px;
}
.workflow .leftLine {
  width: 2%;
  height: 60px;
  position: relative;
  left: -15px;
  top: 12px;
}
.workflow .leftLine .dot {
  position: absolute;
  left: 0;
  width: 9px;
  height: 9px;
  background: rgba(213, 213, 213, 1);
  border-radius: 50%;
}
.workflow .leftLine .line {
  position: absolute;
  left: 3.5px;
  width: 1px;
  height: 270px;
  background: rgba(213, 213, 213, 1);
}
.workflow .botLine {
  margin-bottom: 20px;
  width: 95%;
  float: right;
  border-bottom: 1px dashed rgba(225, 225, 225, 1);
  padding-bottom: 35px;
}
.workflow .leftMsg {
  width: 16%;
  height: 60px;
  position: relative;
  text-align: left;
  left: 0px;
  line-height: 33px;
}
.workflow .leftMsg .type {
  position: absolute;
  left: 0;
  width: 100%;
  font-size: 28px;
  color: rgba(17, 17, 17, 1);
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  -ms-text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}
.workflow .leftMsg .typeMsg {
  position: absolute;
  top: 30px;
  left: 0;
  width: 100%;
  font-size: 24px;
  color: rgba(102, 102, 102, 1);
}
.workflow .content {
  width: 80%;
  min-height: 100px;
  height:auto;
  position: relative;
  right: 0;
}
.workflow .content .fr {
  width: 80px;
  text-align: center;
  margin-right: 15px;
}
.workflow .content .fr p{
    margin-top: .4vw;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 24px;
}
.workflow .content .fr .msg {
  width: 66px;
  height: 66px;
  background: rgba(65, 150, 255, 1);
  border-radius: 50%;
  text-align: center;
  line-height: 66px;
  color: #fff;
  font-size: 24px;
  margin-left: 8%;
}
.workflow .content div p {
  text-align: center;
  font-size: 24px;
  color: rgba(102, 102, 102, 1);
  line-height: 30px;
}

.workflow .content .more {
  width: 66px;
  height: 66px;
  background: rgba(255, 255, 255, 1);
  background-image: url(~@/assets/common/more.png);
  background-size: 66px 66px;
  /* border:1px dashed rgba(65,150,255,1); */
  border-radius: 50%;
}
.workflow .content .add .msg {
  width: 66px;
  height: 66px;
  background: rgba(255, 255, 255, 1);
  border-radius: 50%;
}
.workflow .content .add {
  width: 66px;
  height: 66px;
  background: rgba(255, 255, 255, 1);
  background-image: url(~@/assets/common/addpig.png);
  background-size: 66px 66px;
  border-radius: 50%;
}
.workflow .content .chose {
  width: 66px;
  height: 66px;
  background: rgba(255, 255, 255, 1);
  background-image: url(~@/assets/common/addpig.png);
  background-size: 66px 66px;
  border-radius: 50%;
}
.workflow .content .dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  // background-image: url(~@/assets/common/del.png);
  background-size: 18px;
  float: left;
  margin-left: 25px;
  margin-top: -5px;
}
.pupCon {
  width: 100%;
  background-color: #fff;
  .title {
    text-align: center;
    line-height: 100px;
    font-size: 32px;
  }
  .msg {
    color: #666666;
    text-align: left;
    line-height: 20px;
    font-size: 22px;
    text-indent: 30px;
  }
  .leaveType {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    div {
      flex: inherit;
      text-align: -webkit-center;
    }
    div > h1 {
      display: block;
      height: 66px;
      width: 66px;
      line-height: 66px;
      background-color: #4196ff;
      border-radius: 50%;
      font-size: 24px;
      color: #ffffff;
      margin-left: 30px;
    }
    div > p {
      font-size: 24px;
      margin-left: 30px;
      line-height: 60px;
    }
    .add {
      width: 66px;
      height: 66px;
      background: rgba(255, 255, 255, 1);
      background-image: url(~@/assets/common/addpig.png);
      background-size: 66px 66px;
      border-radius: 50%;
    }
  }
}
.foot-btn {
  height: 140px;
  background: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
}
.foot-btn > .num-box {
  width: 230px;
  height: 90px;
  background: #f2f2f2;
  border-radius: 0 45px 45px 0;
  margin-top: 26px;
}

.foot-btn > .num-box > .num-select {
  display: block;
  margin-left: 48px;
  margin-top: 20px;
}
.foot-btn > .num-box > .num-select > .num-icon {
  display: inline-block;
  width: 36px;
}

.foot-btn > .num-box > .num-text {
  display: block;
  margin-left: 48px;
  color: #040404;
  font-size: 28px;
  font-weight: bold;
}
.foot-btn > .num-box > .num-text > span {
  color: #040404;
  font-size: 20px;
}
.foot-btn > .num-sure {
  width: 220px;
  height: 74px;
  font-size: 32px;
  margin-top: 38px;
  margin-right: 32px;
}
</style>
